import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRoutes } from '../routes/app.routes';
import { HttpService } from 'app/services/http/http.service';

@Injectable({
    providedIn: 'root'
})
export class FileHandler {

    private baseUrl = ApiRoutes.api.baseUrl;
    private routes = ApiRoutes.api;

    constructor(private http: HttpClient, private httpService: HttpService) { }

    single(files: any[]) {
        let selectedFile = '';
        files.forEach((file: any) => {
            selectedFile = URL.createObjectURL(file);
        });
        return selectedFile;
    }

    multiple(files: any[]) {
        const selectedFile: string[] = [''];
        files.forEach((file: any) => {
            selectedFile.push(URL.createObjectURL(file));
        });
        return selectedFile;
    }

    fileUpload(form: FormData, reason: string) {
        // return this.httpService.makeRequest({
        //     action: '' as any,
        //     path: 'file-upload' as any,
        //     method: 'post',
        //     options: {
        //         body: form,
        //         id:reason
        //     },
        //     loader: {
        //         type: 'spinner',
        //     },
        //     isAuthRoutes: true,
        // });
        return this.http.post<any>(`${this.baseUrl}${this.routes.fileUpload.single}/${reason}`, form);
    }

    fileUploadForBulkImport(form: FormData, entity: string, override?: boolean) {
        return this.http.post<any>(`${this.baseUrl}${this.routes.fileUpload.single}/${this.routes.bulkActions['bulk-import']}?name=${entity}&override=${override}`, form);
    }

    manyFilesUpload(form: FormData,reason: string) {
        return this.http.post<any>(`${this.baseUrl}${this.routes.fileUpload.files}/${reason}`, form);
    }
}
